import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ClinicStatus from './ClinicStatus';
import ClinicAddress, { ADDRESS_FORMAT } from './ClinicAddress';
import IconWrapper from './IconWrapper';
import styled from 'styled-components';
import AcceptInsuranceTypes from './AcceptInsuranceTypes';
import { smallerThan } from '../../../../core/util/styledComponents';
import { getAcceptedInsurances, isBookable } from '../../../../core/util/location';
import { isEmpty } from '../../../../core/util/empty';
import { colors } from '../../../../constants/colors';
import { shouldShowFeature, RECENTLY_BOOKED } from '../../util/customization';
import { isMobile } from '../../../../core/util/device';
import RecentlyBookedCopy from './RecentlyBookedCopy';
import { safeGet } from '../../../../core/util/object';

const QuickDetailsContainer = styled.div`
  ${smallerThan.md`
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`;

const Ul = styled.ul`
  list-style-type: none;
  padding-top: 7px;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 0;
  -webkit-padding-start: 0;
`;

const Li = styled.li`
  padding-top: 5px;
`;

const StyledInsuranceIcon = styled.img`
  margin-right: 12px;
`;

const StyledMapDirectionIcon = styled.img`
  margin-right: 9px;
  margin-top: 5px;
  width: 16px;
`;

const StyledHospitalIcon = styled.img`
  margin-right: 10px;
  margin-top: 2px;
`;

const StyledRecentlyBookedIcon = styled.img`
  margin-right: 9px;
`;

const StyledSolvVerifiedIcon = styled.img`
  width: 16px;
  margin-right: 9px;
  margin-bottom: 5px;
  vertical-align: middle;
`;

const SolvVerifiedCopy = styled.div`
  text-transform: uppercase;
  font-size: 14px;
  color: ${colors.squid};
`;

class QuickDetails extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    className: PropTypes.string,
  };

  shouldShowRecentlyBooked = () =>
    Boolean(
      isMobile() &&
        safeGet(this.props.location)('recentBookings') &&
        shouldShowFeature(RECENTLY_BOOKED, this.props.location)
    );

  shouldShowSolvVerified = () => isBookable(this.props.location) && !isMobile();

  render = () => {
    const { displayNamePrimary } = this.props.location;
    const insurances = getAcceptedInsurances(this.props.location);

    return (
      <QuickDetailsContainer>
        <Ul className={this.props.className}>
          {this.shouldShowSolvVerified() && (
            <Li>
              <IconWrapper>
                <StyledSolvVerifiedIcon
                  src="/images/icons/graphic-verified-lrg.svg"
                  alt={`Solv Verified for ${displayNamePrimary}`}
                />
                <SolvVerifiedCopy>Solv Verified</SolvVerifiedCopy>
              </IconWrapper>
            </Li>
          )}
          <Li>
            <IconWrapper>
              <StyledHospitalIcon
                src="/images/icons/business_hours.svg"
                alt={`Business Hours for ${displayNamePrimary}`}
              />
              <ClinicStatus location={this.props.location} />
            </IconWrapper>
          </Li>
          <Li>
            <IconWrapper>
              <StyledMapDirectionIcon
                src="/images/icons/directions_map.svg"
                alt={`Map and Directions for ${displayNamePrimary}`}
              />
              <ClinicAddress type={ADDRESS_FORMAT.VERBOSE} location={this.props.location} />
            </IconWrapper>
          </Li>
          {!isEmpty(insurances) && (
            <Li>
              <IconWrapper>
                <StyledInsuranceIcon
                  src="/images/icons/insurance_shield.svg"
                  alt={`Insurances Accepted at ${displayNamePrimary}`}
                />
                <AcceptInsuranceTypes location={this.props.location} />
              </IconWrapper>
            </Li>
          )}
          {this.shouldShowRecentlyBooked() && (
            <Li>
              <IconWrapper>
                <StyledRecentlyBookedIcon
                  src="/images/icons/recently_booked.svg"
                  alt={`Recent Bookings for ${displayNamePrimary}`}
                />
                <RecentlyBookedCopy location={this.props.location} />
              </IconWrapper>
            </Li>
          )}
        </Ul>
      </QuickDetailsContainer>
    );
  };
}

export default QuickDetails;
